import { IconProps } from '.';
const FingerprintIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      className={customClasses}
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9246 24.3547V18.1227H22.4246V24.3547C22.4246 26.7904 21.8859 29.347 21.0237 31.6168C20.1656 33.8757 18.9513 35.9435 17.528 37.3458L15.7734 35.565C16.8634 34.4911 17.9111 32.7705 18.6866 30.729C19.458 28.6985 19.9246 26.4429 19.9246 24.3547Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.98421 17.778C6.98421 15.1409 7.10666 12.3568 9.69269 9.4834L11.5509 11.1558C9.61309 13.309 9.48421 15.2815 9.48421 17.778C9.48421 17.9426 9.48483 18.1094 9.48545 18.2784C9.49447 20.7107 9.50522 23.6097 7.70118 26.96L5.5 25.7748C6.9962 22.9961 6.99069 20.6674 6.98493 18.233C6.98457 18.0818 6.98421 17.9302 6.98421 17.778Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.4532 7.0665C22.4526 5.33767 17.5494 5.78467 13.9144 8.7381L12.3379 6.79781C16.7454 3.21674 22.6491 2.69912 27.4449 4.77162C32.2866 6.86393 35.9902 11.5893 35.9902 18.368V18.3869C35.9902 20.3854 35.9902 22.6783 35.8622 24.7896C35.7361 26.8706 35.4793 28.9336 34.8955 30.3932L32.5743 29.4648C32.9957 28.4112 33.2416 26.7042 33.3668 24.6384C33.4898 22.6094 33.4902 20.3863 33.4902 18.368C33.4902 12.6174 30.408 8.77553 26.4532 7.0665Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.6756 10.2309C25.4323 10.5921 29.265 13.5395 28.9611 18.4018L26.4659 18.2459C26.6647 15.0657 24.2142 12.9865 21.4364 12.7194C20.0705 12.5881 18.7432 12.9226 17.7494 13.7163C16.7784 14.492 16.0024 15.8042 15.8928 17.8869C15.8683 18.3523 15.8782 18.9052 15.8902 19.581C15.8964 19.9281 15.9032 20.3076 15.9062 20.7243C15.9146 21.9014 15.8883 23.2714 15.6986 24.7064C15.3188 27.5802 14.2716 30.7964 11.4595 33.3272L9.78711 31.4689C12.0016 29.4759 12.8857 26.9096 13.2202 24.3788C13.3877 23.1115 13.4143 21.8738 13.4062 20.7422C13.4038 20.409 13.398 20.0735 13.3922 19.7453C13.3793 19.0092 13.3671 18.3098 13.3963 17.7555C13.538 15.063 14.5841 13.0451 16.1892 11.763C17.7715 10.4991 19.7743 10.0481 21.6756 10.2309ZM25.6757 29.8382C26.2177 27.3646 26.4635 24.5576 26.4635 21.8424H28.9635C28.9635 24.6934 28.7067 27.6854 28.1177 30.3733C27.5346 33.0347 26.5989 35.5241 25.1552 37.2566L23.2347 35.6561C24.3042 34.3727 25.1278 32.3382 25.6757 29.8382Z"
        fill={color}
      />
    </svg>
  );
};

export default FingerprintIcon;
